import { gql } from '../../../__generated__/graphql/catalog'
import { CollectionGridSectionFragmentFragment } from '../../../__generated__/graphql/catalog/graphql'

export type CollectionFiltersConfig = NonNullable<
  CollectionGridSectionFragmentFragment['filterConfig']
>

export const filterKeysFromFilterConfig = (
  filterConfig: CollectionFiltersConfig | undefined | null
): string[] => {
  return (filterConfig?.filters ?? []).map(filter => {
    return filter.name
  })
}

// Get collection view + static portal configuration
export const FETCH_COLLECTION_LAYOUT = gql(`
  query GetCollectionView(
    $collectionHandle: String!
    $preview: Boolean = false
    $withPortal: Boolean = false
  ) {
    collectionView(handle: $collectionHandle, preview: $preview) {
      id
      ...CollectionLayoutFragment
    }
    portal(collectionHandle: $collectionHandle, preview: $preview) @include(if: $withPortal) {
      id
      ...PortalStatic
    }
  }
`)
